// ESM-Huelle um lib/scripts/pos/netcomm/CLS_CDataListener.js (Phase 4, Welle 4b).
// Prototype-Stil bleibt vorerst.
//******************************************************************************
// CDataListener
//******************************************************************************
// Description:
//      Listens to incoming data on an input stream connections and sends the
//      input to a callback function.
// Parameters:
//      inputStream - Pointer to an input stream object.
//      host - host of the connected client.
//      dataCallback - Pointer to the callback function of type 'function (class,
//          data, host)'.
//******************************************************************************

// *** Constructor ***
function CDataListener (inputStream, host, dataCallback)
{
    this.inputStream = inputStream;
    this.host = host;
    this.dataCallback = dataCallback;
}
// ***

// *** Class variables ***
CDataListener.prototype.inputStream = null;
CDataListener.prototype.host = null;
CDataListener.prototype.dataCallback = null;
CDataListener.prototype.data = "";
CDataListener.prototype.input = "";
CDataListener.prototype.dataLength = 0;
CDataListener.prototype.missingDataLength = 0;
CDataListener.prototype.dataLengthCollector = "";
// ***

// *** Class methods ***
//------------------------------------------------------------------------------
// Description:
//      Runs when a request comes in - does nothing for now.
//------------------------------------------------------------------------------
CDataListener.prototype.onStartRequest = function (request, context) {}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Runs when a request finishes - does nothing for now.
//------------------------------------------------------------------------------
CDataListener.prototype.onStopRequest = function (request, context, status) {}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Runs when data becomes available. Sends the input character by character
//      to the dispatcher.
//------------------------------------------------------------------------------
CDataListener.prototype.onDataAvailable = function (request, context,
    inputStream, offset, count)
{
    /*privMan.enablePrivilege (privList);*/

    this.input += this.inputStream.read (count);

//    setTimeout (this.loadData, 0, this);
    this.executeData();
}
//------------------------------------------------------------------------------

CDataListener.prototype.executeData = function ()
{
    this.dataCallback (this.input);
    this.input = "";
}

CDataListener.prototype.loadData = function (me)
{
    /*privMan.enablePrivilege (privList);*/

    var n = 0;

    while (me.input.length > 0)
    {
        if (me.dataLength == 0)
        {
            me.lengthDetect (me.input.substr (0, 1));
            me.input = me.input.substr (1, me.input.length - 1);
        }
        else
        {
            var missing = me.dataLength - me.data.length;

            me.data += me.input.substr (0, missing);
            me.input = me.input.substr (missing, me.input.length - missing);

            if (me.data.length == me.dataLength)
            {
                me.dataCallback.fnc (me.dataCallback.cls, me.data, me.host);
                me.data = "";
                me.dataLength = 0;
                me.dataLengthCollector = "";
            }
            else if (me.input.length > me.dataLength)
            {
                me.data = "";
                me.dataLength = 0;
                me.dataLengthCollector = "";
            }
        }
    }
}

CDataListener.prototype.lengthDetect = function (chr)
{
    if (parseInt (chr) || chr == "0")
        this.dataLengthCollector += chr;
        
    if (chr == "\n" && this.dataLengthCollector != "")
        this.dataLength = parseInt (this.dataLengthCollector);
}
// ***

//******************************************************************************
export { CDataListener };
